module.exports = __webpack_public_path__ + "assets/img/img-9.48d1b2e3.png";